import React from 'react';
import { Section } from 'react-scale/containers/corp/backfills/batch/components/Section';
import SectionTitle from 'corp/components/UI/SectionTitle';
import BackfillESCIAttempts from 'react-scale/corp/components/ImbeESCI/BackfillESCIAttempts';
import { ReturnBatchToImbe } from 'react-scale/corp/components/ImbeESCI/ReturnBatchToImbe';
import { CreateVendorTasks } from 'react-scale/corp/components/ImbeESCI/CreateVendorTasks';
import { GroupVendorTasks } from 'react-scale/corp/components/ImbeESCI/GroupVendorTasks';

function EsciRelevanceActions() {
  return (
    <div className="root">
      <SectionTitle title="ESCI/Relevance Actions" />
      <Section name={'Return Batch to Imbe API'} forceHidden={true}>
        <ReturnBatchToImbe />
      </Section>
      <Section name={'Backfill ESCI Attempts'} forceHidden={true}>
        <BackfillESCIAttempts />
      </Section>
      <Section name={'Create ESCI Tasks'} forceHidden={true}>
        <CreateVendorTasks />
      </Section>
      <Section name={'Group Vendor Tasks'} forceHidden={true}>
        <GroupVendorTasks />
      </Section>
      <Section name={'Generate Delivery Files'} forceHidden={true}>
        <p>Generate JSON and CSV delivery files for ESCI/Relevance projects</p>
        <p>
          You can find this tool{' '}
          <a target="_blank" href="/corp/dct/imbe-esci-relevance-generate-output">
            clicking here
          </a>
        </p>
        <GroupVendorTasks />
      </Section>
    </div>
  );
}
export default EsciRelevanceActions;
